// extracted by mini-css-extract-plugin
export default {"username":"UsernameFooter_username__sB2EN"};